var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNoUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#FAE6E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.876 47.7447C52.4331 47.7447 56.938 43.2398 56.938 37.6827C56.938 32.1256 52.4331 27.6207 46.876 27.6207C41.3189 27.6207 36.814 32.1256 36.814 37.6827C36.814 43.2398 41.3189 47.7447 46.876 47.7447Z",
    stroke: "#A51713",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5898 67.8688C29.5898 60.0808 37.3376 53.782 46.8764 53.782C48.8083 53.782 50.6798 54.0436 52.4306 54.5266",
    stroke: "#A51713",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0001 59.819C67.0001 60.463 66.9196 61.0868 66.7586 61.6905C66.5775 62.4955 66.2555 63.2803 65.8329 63.9646C64.4444 66.2989 61.8886 67.8686 58.9505 67.8686C56.8777 67.8686 55.0062 67.0837 53.5975 65.7958C52.9938 65.2726 52.4705 64.6488 52.068 63.9646C51.3235 62.7571 50.9009 61.3283 50.9009 59.819C50.9009 57.6456 51.7662 55.6534 53.1749 54.2045C54.644 52.6952 56.6966 51.7694 58.9505 51.7694C61.3251 51.7694 63.4784 52.7958 64.9273 54.4459C66.2153 55.8747 67.0001 57.7664 67.0001 59.819Z",
    stroke: "#A51713",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.023 57.6859L56.7769 61.932",
    stroke: "#A51713",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8164 57.7261L61.0827 61.9722",
    stroke: "#A51713",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoUser);
export default __webpack_public_path__ + "static/media/icon_no_user.affadb7bcc48a15c3167cce462c40f01.svg";
export { ForwardRef as ReactComponent };